import { Node } from '@tiptap/core'

export const FieldToken = Node.create({
  name: 'field_token',

  inline: true,
  group: 'inline',
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      field: { default: null },
      label: { default: null },
    }
  },

  parseHTML() {
    return [{ tag: 'field-token' }]
  },

  renderHTML({ node }) {
    const label =
      node.attrs.label ??
      node.attrs.field
        ?.replace(/_/g, ' ')
        .replace(/\b\w/g, c => c.toUpperCase()) ??
      ''

    return [
      'field-token',
      {
        'data-field': node.attrs.field,
        class: 'chart_field_token',
        contenteditable: 'false',
      },
      `{${label}}`,
    ]
  },
})
